import React, { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import {
  addAdditionalServiceRule,
  getAdditionalServiceRulesDataAsync,
  removeAdditionalServiceRule,
  selectAdditionalServiceRulesItemsData,
  selectAdditionalServiceRulesLoadingStatus,
  updateAdditionalServiceField,
  updateSeasonRateAdditionalServiceRulesAsync,
} from '../seasonRateRulesSlice';
import { AddonServiceRuleItemsData } from '../../../common/types/rates.types';
import AddonServiceRulesForm from './AddonServiceRulesForm';
import {
  getAccommodationAddOnsAsync,
  selectAccommodationAddOns,
  selectAccommodationAddOnsLoadingStatus,
} from '../../accommodations/accommodationsSlice';

function SeasonRateAddonServiceRules({
  seasonRateId,
  accommodationId,
  hasWriteAccess,
}: {
  seasonRateId: string;
  accommodationId: string;
  hasWriteAccess: boolean;
}) {
  const dispatch = useAppDispatch();
  const addonServiceRuleItemsData = useAppSelector(
    selectAdditionalServiceRulesItemsData,
  );
  const accommodationAddons = useAppSelector(selectAccommodationAddOns);
  const addonServiceRuleItemsDataStatus = useAppSelector(
    selectAdditionalServiceRulesLoadingStatus,
  );
  const accommodationAddonsStatus = useAppSelector(
    selectAccommodationAddOnsLoadingStatus,
  );

  const initialData: AddonServiceRuleItemsData = {
    seasonRateId,
    additionalServiceRules: [],
  };

  const [data, setData] = useState(initialData);
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    dispatch(getAccommodationAddOnsAsync(accommodationId));
    dispatch(
      getAdditionalServiceRulesDataAsync({ seasonRateId, accommodationId }),
    );
  }, [seasonRateId, accommodationId]);

  useEffect(() => {
    if (addonServiceRuleItemsData && addonServiceRuleItemsData.seasonRateId) {
      setData(addonServiceRuleItemsData);
    } else {
      setData(initialData);
    }
  }, [addonServiceRuleItemsData]);

  useEffect(() => {}, [data]);

  const handleInputChange =
    (index: string, field: string) =>
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const { type, checked, value } = event.target;
      dispatch(
        updateAdditionalServiceField({
          index,
          field,
          value: type === 'checkbox' ? checked : value,
        }),
      );
    };

  const handleSelectChange = (selectedOption, index, field) => {
    dispatch(
      updateAdditionalServiceField({
        index,
        field,
        value: selectedOption ? selectedOption.value : null,
      }),
    );
  };

  const handleAddRule = (addonDefinitionId: string, addonName: string) => {
    const newRule = {
      additionalServiceId: addonDefinitionId,
      additionalServiceName: addonName,
      isMandatory: true,
      priceChange: {
        priceChangeType: 2,
        difference: 0,
        percent: 0,
      },
      isCopyable: true,
    };
    dispatch(addAdditionalServiceRule(newRule));
  };

  const handleRemoveRule = index => {
    dispatch(removeAdditionalServiceRule(index));
  };

  const onSubmit = () => {
    dispatch(updateSeasonRateAdditionalServiceRulesAsync(data));
    setSubmitted(true);
  };

  return (
    <AddonServiceRulesForm
      loadingStatus={addonServiceRuleItemsDataStatus}
      addonsLoadingStatus={accommodationAddonsStatus}
      handleInputChange={handleInputChange}
      handleSelectChange={handleSelectChange}
      onSubmit={onSubmit}
      submitted={submitted}
      data={data}
      accommodationAddons={accommodationAddons}
      hasWriteAccess={hasWriteAccess}
      handleAddRule={handleAddRule}
      handleRemoveRule={handleRemoveRule}
    />
  );
}

export default SeasonRateAddonServiceRules;
